"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCarousel = exports.CATEGORY_CAROUSEL_PRODUCT_CATEGORY_SELECT = exports.CATEGORY_CAROUSEL_QUERY = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CategoryCarouselView_1 = require("./views/CategoryCarouselView");
exports.CATEGORY_CAROUSEL_QUERY = 'getProductCategory';
exports.CATEGORY_CAROUSEL_PRODUCT_CATEGORY_SELECT = {
    slug: true,
    title: true,
    description: true,
    products: {
        title: true,
        images: true,
        slug: true,
    },
};
function CategoryCarousel({ slug, }) {
    var _a;
    const { data } = (0, app_1.useQuery)(exports.CATEGORY_CAROUSEL_QUERY, {
        args: {
            slug,
        },
        select: exports.CATEGORY_CAROUSEL_PRODUCT_CATEGORY_SELECT,
    });
    return ((0, jsx_runtime_1.jsx)(CategoryCarouselView_1.CategoryCarouselView, { category: data === null || data === void 0 ? void 0 : data.title, description: data === null || data === void 0 ? void 0 : data.description, products: (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [], slug: data === null || data === void 0 ? void 0 : data.slug }));
}
exports.CategoryCarousel = CategoryCarousel;
